import type { SearchGroup, SearchGroupResult } from "src/http/types";

// TODO(WEBF-755): drop the ServiceStack names once the ServiceStack page serializer, which ignores [JsonProperty], is deleted.
type ServiceStackSearchGroup = SearchGroup & { readonly searchResults?: SearchGroup["results"] };
type ServiceStackSearchGroupResult = SearchGroupResult & { readonly indexId?: string | null };

export const getSearchGroupResults = (group: Maybe<ServiceStackSearchGroup>) => group?.results ?? group?.searchResults;

export const getSearchResultIndexName = (result: ServiceStackSearchGroupResult) => result.indexName ?? result.indexId;
